import { render, staticRenderFns } from "./TextComponentWithExtraIcons.vue?vue&type=template&id=524beec6"
import script from "./TextComponentWithExtraIcons.vue?vue&type=script&lang=js"
export * from "./TextComponentWithExtraIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports